module.exports = __webpack_public_path__ + "img/02.7fa8aa82.jpg";